import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play--banner",
  "use": "icon-play--banner-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-play--banner\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 1h24a1 1 0 0 1 1 1v24a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1ZM0 2a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v24a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm19.125 12.216a.25.25 0 0 0 0-.432l-7.5-4.33a.25.25 0 0 0-.375.216v8.66a.25.25 0 0 0 .375.217l7.5-4.33Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol